import { useMemo, JSX } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RolesAndPermissionsDatagrid } from '../../components/DataGrid/RolesAndPermissions/RolesAndPermissionsDatagrid';
import { findActiveMenuItem } from '../../helpers';
import { IRootState } from '../../types/store';
import { PermissionsDatagrid } from '../../components/DataGrid/PermissionsDatagrid';

export const RoleAccessAndPermissionsPage = () => {
  const location = useLocation();
  const menuItems = useSelector((state: IRootState) => state.user.menuItems);
  const activeSubMenu = useMemo(
    () => findActiveMenuItem(menuItems, location.pathname),
    [menuItems, location.pathname],
  );

  const RenderedDatagrid: Record<string, JSX.Element> = {
    Roles: <RolesAndPermissionsDatagrid />,
    Permissions: <PermissionsDatagrid />,
  };

  return <>{activeSubMenu?.title && RenderedDatagrid[activeSubMenu.title]}</>;
};
